import api from '@/api';
import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SAVE_OFFER_PARTNERS_FILTERS: 'SAVE_OFFER_PARTNERS_FILTERS',
    SAVE_OFFER_FORM_PARTNERS_FILTERS: 'SAVE_OFFER_FORM_PARTNERS_FILTERS',
    SAVE_OFFER_BANNERS_FILTERS: 'SAVE_OFFER_BANNERS_FILTERS',
    RECEIVE_DETAILS: 'RECEIVE_OFFER',
    RECEIVE_OFFER_BANNERS: 'RECEIVE_OFFER_BANNERS',
    RESET_OFFER_BANNERS_FILTERS: 'RESET_OFFER_BANNERS_FILTERS',
    RESET_OFFER_PARTNERS_FILTERS: 'RESET_OFFER_PARTNERS_FILTERS',
    RESET_OFFER_FORM_PARTNERS_FILTERS: 'RESET_OFFER_FORM_PARTNERS_FILTERS',
};

const initialState = {
    data: { data: [] },
    banners: [],
    bannersFilters: { sort: '-created', limit: localConfig.defaultListLimit },
    partners: {
        data: [],
        meta: {},
        filters: { sort: '-created', limit: localConfig.defaultListLimit },
    },
    formPartnersFilters: { sort: '-created', limit: localConfig.defaultListLimit },
};

const state = { ...initialState };


const getters = {
    offerBannersFilters: state => state.bannersFilters,
    offerBanners: state => state.banners,
    offerPartnersFilters: state => state.partners.filters,
    offerFormPartnersFilters: state => state.formPartnersFilters,
};


const actions = {
    saveOfferPartnersFilters ({ commit }, payload) {
        commit(types.SAVE_OFFER_PARTNERS_FILTERS, { payload });
    },
    saveOfferFormPartnersFilters ({ commit }, payload) {
        commit(types.SAVE_OFFER_FORM_PARTNERS_FILTERS, { payload });
    },
    saveOfferBannersFilters ({ commit }, payload) {
        commit(types.SAVE_OFFER_BANNERS_FILTERS, { payload });
    },
    getOffer ({ commit }, id) {
        return api.offers.get(id).then((response) => {
            commit(types.RECEIVE_DETAILS, { data: response.data.data });
        });
    },
    getOfferBanners ({ commit }, id) {
        return api.offers.bannersList(id).then((response) => {
            commit(types.RECEIVE_OFFER_BANNERS, { data: response.data.data, id: id } );
        });
    },
    resetOfferBannersFilters ({ commit }) {
        commit(types.RESET_OFFER_BANNERS_FILTERS);
    },
    resetOfferPartnersFilters ({ commit }) {
        commit(types.RESET_OFFER_PARTNERS_FILTERS);
    },
    resetOfferFormPartnersFilters ({ commit }) {
        commit(types.RESET_OFFER_FORM_PARTNERS_FILTERS);
    },
};


const mutations = {
    [types.SAVE_OFFER_PARTNERS_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.partners = {
            ...state.partners,
            filters: { ...payloadNormalized },
        };
    },
    [types.SAVE_OFFER_FORM_PARTNERS_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.formPartnersFilters = { ...payloadNormalized };
    },
    [types.SAVE_OFFER_BANNERS_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.bannersFilters = { ...payloadNormalized };
    },
    [types.RECEIVE_DETAILS] (state, { data }) {
        state.data = data;
    },
    [types.RECEIVE_OFFER_BANNERS] (state, { data }) {
        state.banners = data;
    },
    [types.RESET_OFFER_BANNERS_FILTERS] (state) {
        state.bannerFilters = { ...initialState.bannerFilters };
    },
    [types.RESET_OFFER_PARTNERS_FILTERS] (state) {
        state.partners.filters = { ...initialState.partners.filters };
    },
    [types.RESET_OFFER_FORM_PARTNERS_FILTERS] (state) {
        state.formPartnersFilters = { ...initialState.formPartnersFilters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
